import { BarChartOutlined, InfoCircleOutlined, LineChartOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Radio, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProjectDetailTable } from '@/components/user-resource-dashboard/detail-table/project-detail-table'
import { DashboardLineChart } from '@/components/user-resource-dashboard/user-resource-dashboard-chart/dashboard-chart-line'

export const ProjectTrendProjectDashboardCard: React.FC<{
  selfId: string
}> = ({ selfId }) => {
  const { t } = useTranslation()

  const [chartType, setChartType] = React.useState<'line' | 'interval'>('line')

  const startDate = new URLSearchParams(window.location.search).get('startDate')
  const endDate = new URLSearchParams(window.location.search).get('endDate')

  const { data: trendProjectsData } = useRequest(
    {
      url: '/api/work-resource/statistics/project/trend/projects/data',
      params: {
        startDate,
        endDate,
        selfId,
      },
    },
    {
      initialData: { chart: [], list: [] },
      refreshDeps: [startDate, endDate, selfId],
      ready: !!startDate && !!endDate && !!selfId,
    }
  )

  const data = (trendProjectsData as any) || { chart: [], list: [] }

  return (
    <div className='flex mb-8'>
      <div className='flex-grow mr-16'>
        <div className='flex mb-4 justify-between'>
          <div className='flex font-medium text-lg gap-1 items-baseline'>
            {t(`项目视角`)}
            <Tooltip title={'默认展示时间范围内该项目资源消耗做多的6个普通/自定义项目'}>
              <InfoCircleOutlined className='cursor-pointer text-sm' size={14} />
            </Tooltip>
          </div>
          <div className='flex'>
            <Radio.Group onChange={(e) => setChartType(e.target.value)} value={chartType}>
              <Radio.Button value='line'>
                <LineChartOutlined />
              </Radio.Button>
              <Radio.Button value='interval'>
                <BarChartOutlined />
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <DashboardLineChart
          data={data.chart.map((c: any) => ({
            ...c,
            date: t('dashboard.xAxisLabel', { year: c.year, week: c.week }),
          }))}
          type={chartType}
        />
      </div>
      <div className='flex-shrink-0 w-90'>
        <div className='flex font-medium text-lg mb-4 gap-1 items-baseline'>
          {t(`项目资源明细`)}
          <Tooltip
            title={
              '项目工时百分比：该项目总工时/所有项目工时；团队工时百分比：该项目团队工时/该团队总工时，项目分摊比例已纳入计算。'
            }
          >
            <InfoCircleOutlined className='cursor-pointer text-sm' size={14} />
          </Tooltip>
        </div>
        <ProjectDetailTable list={data!.list as any} />
      </div>
    </div>
  )
}
